"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const styled_system_1 = require("styled-system");
exports.Button = styled_1.default.button(({ theme, size = 'medium', disabled }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: `${theme.iconButtonSizes[size]}`,
    width: `${theme.iconButtonSizes[size]}`,
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
}), ({ highlight, shadow, shape = 'circle', theme, background = 'white' }) => ({
    boxShadow: shadow ? theme.shadow.small : undefined,
    background: theme.colors[background],
    borderRadius: shape === 'square' ? undefined : '50%',
    ':hover': {
        boxShadow: shadow ? theme.shadow.large : undefined,
        backgroundColor: highlight ? theme.colors[highlight] : undefined,
    },
}), styled_system_1.layout, styled_system_1.space);
exports.Button.defaultProps = {
    type: 'button',
};
//# sourceMappingURL=icon_button.styles.js.map